import React from 'react';
import { Routes, Route } from "react-router-dom";
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { Main } from './components/Main';
import { CommunityLookup } from './components/CommunityLookup';
import { AccountSettings } from './components/AccountSettings';
import { CertificateManagementDetails } from './components/CertificateManagementDetails';
import { CertificateSelfService } from './components/CertificateSelfService';
import { ExpirationEventPartners } from './components/ExpirationEventPartners';
import { SsoResponseConnect } from './components/SsoResponseConnect';
import { X12Home } from './components/x12/Home';
import { X12Create } from './components/x12/Create';
import { X12Details } from './components/x12/Details';
import { X12FileContext } from './components/x12/Context';
import { OnboardingHome } from './components/onboarding/Home';
import { OnboardingVendorDetails } from './components/onboarding/VendorDetails';
import { OnboardingVendorTechnicalDetails } from './components/onboarding/VendorTechnicalDetails';

function App()
{
    return (
        <Layout>
            <Routes>
                <Route exact path='/' element={<Home />} />
                <Route exact path='/edi-rsp-cxn' element={<SsoResponseConnect />} />
                <Route path="/main" element={<Main />} />
                <Route path="/accountsettings/:userID" element={<AccountSettings />} />
                <Route path="/communitylookup" element={<CommunityLookup />} />
                <Route path="/certificatedetails/:expirationEventGUID" element={<CertificateManagementDetails />} />
                <Route path="/certificatedetails/:environmentKey/:communityID/:certificateID" element={<CertificateManagementDetails />} />
                <Route path="/certificateselfservice" element={<CertificateSelfService />} />
                <Route path="/certificateselfservice/:userToken" element={<CertificateSelfService />} />
                <Route path="/expirationeventpartners/:expirationEventGUID" element={<ExpirationEventPartners />} />
                <Route path="/x12" element={<X12Home />} />
                <Route path="/x12/create" element={<X12Create />} />
                <Route path="/x12/details/:x12CaseGUID" element={<X12Details />} />
                <Route path="/x12/file/:x12CaseFileGUID" element={<X12FileContext />} />
                <Route path="/onboarding" element={<OnboardingHome />} />
                <Route path="/onboarding/vendor" element={<OnboardingVendorDetails />} />
                <Route path="/onboarding/vendordetails/:userToken" element={<OnboardingVendorTechnicalDetails />} />
                <Route path="/onboarding/vendordetailchange/:userToken" element={<OnboardingVendorTechnicalDetails />} />
            </Routes>
        </Layout>
    );
}

export default App;